<style lang="scss">
    @import '~@/abstracts/_variables.scss';

    div#login-modal {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, .6);
        z-index: 99999;

        div.login-box {
            width: 100%;
            max-width: 530px;
            min-width: 320px;
            padding: 20px;
            background-color: #fff;
            border: 1px solid #ddd;
            -webkit-box-shadow: 0 1px 3px rgba(50, 50, 50, 0.08);
            box-shadow: 0 1px 3px rgba(50, 50, 50, 0.08);
            -webkit-border-radius: 4px;
            border-radius: 4px;
            font-size: 16px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            div.social-link {
                display: block;
                margin: auto;
                width: 230px;
                margin-top: 10px;
                margin-bottom: 10px;
            }

            div.login-label {
                color: black;
                font-family: 'Raleway', sans-serif;
                font-weight: bold;
                text-transform: uppercase;
                text-align: center;
                margin-top: 40px;
                margin-bottom: 20px;
            }

            input.form-input-phone-number {
                text-align: center;
                border-radius: 5px;
            }

            p.learn-more-description {
                color: #666666;
                text-align: center;
            }

            button.contact-button {
                border: 2px solid $secondary-color;
                border-radius: 30px;
                font-family: 'Raleway', sans-serif;
                background-color: white;
                width: 360px;
                font-size: 16px;
                font-weight: bold;
                text-align: center;
                padding: 10px;
                margin-top: 20px;
                display: block;
                margin: auto;
                outline:none;
                cursor: pointer;
                color: $secondary-color;

                &:hover {
                    background-color: $secondary-color;
                    color: white;
                }
            }

            .centered {
                margin: auto;
            }
        }
    }

    /* Small only */
    @media screen and (max-width: 39.9375em) {
        div#login-modal {
            div.login-box {
                width: 95%;

                a.learn-more-button {
                    width: 300px;
                }
            }
        }
    }

    /* Medium only */
    @media screen and (min-width: 40em) and (max-width: 63.9375em) {

    }

    /* Large only */
    @media screen and (min-width: 64em) and (max-width: 74.9375em) {

    }
</style>

<template>
    <div id="login-modal" v-show="show" v-on:click="show = false">
        <div class="login-box" v-on:click.stop="">
            <form @submit.prevent="submitContact">
                <div class="login-label">{{ $t('contact.label') }}</div>

                <div class="social-link cell centered">
                    <input type="text" class="form-input form-input-phone-number" v-model="phone_number" :placeholder="$t('contact.phonePlaceholder')" />
                </div>

                <p class="learn-more-description">
                    {{ $t('contact.description') }}
                </p>

                <button type="submit" class="contact-button">
                    {{ $t('contact.submitButton') }}
                </button>
            </form>
        </div>
    </div>
</template>

<script>
    import {EventBus} from '../../event-bus.js';

    export default {
        data() {
            return {
                show: false,
                phone_number: '',
            }
        },

        mounted() {
            EventBus.$on('prompt-contact', function () {
                this.show = true;
            }.bind(this));
        },

        methods: {
            submitContact() {
                this.show = false;

                this.$store.dispatch('flashMessageShow', { type: 'success', message: this.$t('contact.successMessageSent') }, { root: true })
            },
        }
    }
</script>
